<template>
  <div>
    <v-dialog v-model="patternRequestDialog" max-width="1000">
      <requestsModal />
    </v-dialog>

    <div class="d-flex align-center justify-space-between">
      <div
        class="other-pattern-div my-4"
        @click="patternRequestDialog = true"
        style="cursor: pointer"
      >
        <span>
          Visualizar <strong class="secondary--text">solicitações</strong> de
          uso de padrões
        </span>
      </div>
      <v-btn
        class="secondary-button"
        depressed
        to="/electricalSafety/patternManage"
      >
        Novo padrão
      </v-btn>
    </div>

    <v-tabs
      :height="40"
      :mobile-break-point="360"
      v-model="tab"
      class="ma-0"
      icons-and-text
    >
      <v-tabs-slider color="#BBCF20"></v-tabs-slider>
      <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0">
        Próprios
      </v-tab>
      <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0">
        Emprestados
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" touchless>
      <v-tab-item>
        <InstitutionTable />
      </v-tab-item>
      <v-tab-item>
        <BorrowedTable />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import BorrowedTable from './borrowedPatternTable.vue'
import InstitutionTable from './institutionPatternTable.vue'
import requestsModal from './requestsModal.vue'

export default {
  data() {
    return {
      tab: 0,
      patternRequestDialog: false,
    }
  },

  components: {
    BorrowedTable,
    InstitutionTable,
    requestsModal,
  },

  methods: {},
}
</script>

<style lang="scss" scoped>
@import '@/sass/variables.scss';

.other-pattern-div {
  padding: 10px;
  border-radius: 6px;
  background: #f9f9f9;
  border: 1px solid #e9e9e9;
}

.mobile {
  display: none;
  @media (max-width: $tablet-1) {
    display: block;
  }
}
.desktop {
  @media (max-width: $tablet-1) {
    display: none;
  }
}

.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

p a {
  color: #bbcf20 !important;
  font-size: 1.2rem;
}

.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}

@media (max-width: 360px) {
  p {
    font-size: 1rem !important;
  }
}
</style>
